import { Filters } from '../../../model/Filters'

const all = ['question_instances']
const lists = [...all, 'list']
const list = (filters?: Filters) => [...lists, filters]
const detail = (id: number) => [...all, id]

export const questionInstancesKeys = {
  all,
  lists,
  list,
  detail,
}
